import { type ButtonProps } from 'antd';
import { type ButtonGroupProps } from 'antd/lib/button/button-group';
import { forwardRef } from 'react';

import { StyledButton } from './Button.style';

const Button = forwardRef<HTMLButtonElement, any>(function Button({ ...props }: ButtonProps, ref) {
  return <StyledButton ref={ref} {...props} />;
});

export function ButtonGroup({ ...props }: ButtonGroupProps) {
  return <StyledButton.Group {...props} />;
}

const ButtonNamespace = Object.assign(Button, { Group: ButtonGroup });

export { ButtonNamespace as Button };
